import { cellLineaRazonSocial, emptyCell, emptyCellObject } from "@/shared";
import { OrdenTrabajo } from "@/shared/interfaces";
import { MRT_ColumnDef } from "material-react-table";
import { Chip } from "@mui/material";
import { useMemo } from "react";
import dayjs from "dayjs";
import { duracionTraslado } from "../components/traslados-finalizados/TrasladoFinalizadoDetalle";

/**
 * Columnas de la tabla de traslados finalizados. Reusa el estilo de
 * `useTableColumnsVisitasFinalizadas` pero con los tiempos del traslado
 * (`fecha_hora_*_instalacion`).
 */
export function useTableColumnsTrasladosFinalizados() {
  const columns = useMemo<MRT_ColumnDef<OrdenTrabajo>[]>(
    () => [
      {
        accessorKey: "cliente_razon_social",
        header: "Cliente",
        size: 260,
        Cell: ({ row }) =>
          cellLineaRazonSocial(
            row.original?.contrato_data,
            row.original.prospecto_data?.razon_social!
          ),
      },
      {
        accessorKey: "identificacion",
        header: "Identificación",
        Cell: ({ row }) => row.original?.prospecto_data?.identificacion || "N/A",
      },
      {
        accessorKey: "fecha_hora_fin_instalacion",
        header: "Fin del traslado",
        Cell: ({ row }) =>
          row.original?.fecha_hora_fin_instalacion
            ? dayjs(row.original.fecha_hora_fin_instalacion).format("DD/MM/YYYY HH:mm")
            : "—",
      },
      {
        accessorKey: "duracion",
        header: "Duración",
        Cell: ({ row }) => (
          <Chip
            size="small"
            color="info"
            variant="outlined"
            label={duracionTraslado(
              row.original?.fecha_hora_inicio_instalacion,
              row.original?.fecha_hora_fin_instalacion
            )}
          />
        ),
      },
      {
        accessorKey: "flota_nombre",
        header: "Flota",
        Cell: ({ row }) => row.original?.flota_data?.nombre || "—",
      },
      {
        accessorKey: "ciudad_nombre",
        header: "Ciudad",
        Cell: ({ row }) => emptyCellObject(row.original?.ciudad_data, "nombre"),
      },
      {
        accessorKey: "sector_nombre",
        header: "Sector",
        Cell: ({ row }) => emptyCellObject(row.original?.sector_data, "nombre"),
      },
      {
        accessorKey: "coordenadas",
        header: "Coordenada",
        Cell: ({ row }) => emptyCell(row.original?.coordenadas),
      },
    ],
    []
  );
  return { columns };
}
